<template>
  <div class="children-menu-categories">
    <div class="container">
      <div class="children-menu-categories__grid">
        <template
          v-for="(child) in children"
          :key="`child-${ child.id }`"
        >
          <nuxt-link
            :to="child.url"
            class="children-category-card"
          >
            <div class="children-category-card__image">
              <nuxt-img
                :src="String(child.catalog_image || child.image_id)"
                :alt="child.name"
                :title="child.name"
                widht="421"
                height="276"
                fit="default"
              />
            </div>
            <div class="children-category-card__body">
              {{ child.name }}
            </div>
          </nuxt-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import type { ICategory } from '#sitis/internal/controllers/categories/models/Category';
import type { ComputedRef } from 'vue';

interface IProps {
  category: ICategory | null,
}
const props = withDefaults(defineProps<IProps>(), {
  category: null
});

const children: ComputedRef<any> = computed(() => {
  const _children = props?.category?.dynamicFields?.children || [];
  return _children.filter((t: any) => Boolean(t.show_in_menu))
});
</script>

<style scoped lang="scss">
.children-menu-categories {
  margin-top: 32px;
}
.children-menu-categories__grid {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.children-category-card {
  border: 1px solid #F4F3F1;
  background-color: #F4F3F1;
  position: relative;
  border-radius: 20px;
  overflow: hidden;

  &:hover {
    .children-category-card__body {
      text-decoration: underline;
    }
    .children-category-card__image {
      & > img {
        transform: scale(1.1);
      }
    }
  }
}
.children-category-card__image {
  display: flex;
  position: relative;
  overflow: hidden;
  border-radius: 0 0 20px 20px;

  img {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    object-fit: cover;
    transition: transform 0.2s ease;
  }
  &:after {
    content: "";
    float: left;
    padding-top: 65.575%;
  }
}
.children-category-card__body {
  padding: 32px;
  box-sizing: border-box;

  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  color: #000000;
}

@media (max-width: 1599px) {
  .children-menu-categories__grid {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
@media (max-width: 1439px) {
  .children-menu-categories__grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 1199px) {
  .children-category-card__body {
    padding: 20px;
  }
}
@media (max-width: 1023px) {
  .children-category-card {
    &:hover {
      .children-category-card__image {
        & > img {
          transform: none;
        }
      }
    }
  }
  .children-category-card__body {
    padding: 20px 16px;
    font-size: 16px;
  }
}
@media (max-width: 859px) {
  .children-menu-categories__grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 639px) {
  .children-menu-categories__grid {
    grid-template-columns: 1fr;
  }
}
</style>
